import { ID, IDPrefixes } from '@griply/types';

import {
  getCompositeIdParts,
  hasCompositeIdPrefix,
} from '../encoded-ids/composite-id';

export const getTaskIdFromTreeId = (id: ID): ID => {
  if (hasCompositeIdPrefix(id, IDPrefixes.Occurrence)) {
    return getCompositeIdParts(id, IDPrefixes.Occurrence)?.[1] ?? id;
  }
  return id;
};
